import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '../../../components'
import './filter.scss'
import FilterCiclo from './filterCiclo'
import FilterData from './filterData'
import { filterHandle, putFiltersProvisorio, setFiltersProvisorio } from '../redux/basededadosActions'

export default () => {
  const dispatch = useDispatch()
  const { projeto, filters, filterActive, listas: {typeSearch}, ciclos } = useSelector(state=> state.layoutState)
  const { filtersProvisorio, paginate } = useSelector(state=> state.basededadosState)
  
  useEffect(()=> {
    let filtros = filters
    if (!filters?.ciclo?.anoMes  && ciclos.length) {
      filtros = {...filtros, ciclo: ciclos[ciclos.length - 1]}
    }
    dispatch(setFiltersProvisorio(filtros))
  }, [ciclos])

  const handleSearching = (params) => {
    dispatch(filterHandle({projetoID: projeto.id, params, filterActive, typeSelect: params.typeSelect, paginate}))
  }
  
  const contentFilterType = (e) => {
    switch (e?.id) {
      case 'Ciclo':
        return <FilterCiclo />;
      case 'Data':
        return <FilterData />;
      default:
        return;
    }
  }
  
  return (
    <div className='box-basededados-search box-content'>
      <div className='box-basededados-search-box'>
        <div className='box-basededados-search-type'>
          {
            typeSearch.map((type)=> {
              return <Button
                color={'primary'}
                type={type.id === filtersProvisorio?.typeSelect?.id?'btn':'link'}
                size='small'
                onClick={()=> dispatch(putFiltersProvisorio({name: 'typeSelect', value: type}))}
                key={type.id}
              >
                {type.label}
              </Button> 
            })
          }
          <p>{filtersProvisorio?.typeSelect?.text}</p>
        </div>
        <div>
          {contentFilterType(filtersProvisorio.typeSelect)}
        </div>

      </div>
      <div className='box-basededados-search-action'>
        <Button
          color='primary'
          size='large'
          onClick={()=> handleSearching(filtersProvisorio)}
        >Pesquisar</Button>          
      </div>
    </div>
  )
}
